import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import PageTitle from '../../../common/components/PageTitle';
import NewButton from '../../../common/components/buttons/NewButton';
import EventsFilterMenu from '../components/EventsFilterMenu';
import EventChron from '../components/EventChron';
import styles from './EventsContainer.scss';
import {
  loadEvents,
  loadEventChronPage,
  sortEventChron,
  filterEventChron,
  resetEventListing,
} from '../modules/eventChron';

/**
 * Container for Events listing.
 */
export class EventsContainer extends Component {
  state = {
    keyword: this.props.keywordFilter,
    venue: this.props.venueFilter,
    time: this.props.timeFilter,
    eventsType: '',
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.location.pathname === '/events' &&
      prevProps.location.pathname === '/events/cms'
    ) {
      this.props.loadEvents(false);
    }
  }

  componentDidMount() {
    const now = new Date();
    const diff = Math.floor(now - this.props.lastFetched);
    const sessionIdle = Math.floor(diff / 1000);
    if (sessionIdle > 300) {
      this.props.loadEvents(false);
    } else if (!this.props.lastFetched || this.props.events.length < 1) {
      this.props.loadEvents(false);
    }
    if (window.location.pathname.includes('cms')) {
      this.setState({ eventsType: 'cmsOnly' });
      this.props.loadEvents(true);
    }
  }

  handlePageChange = (newPage) => {
    this.props.loadPage(newPage);
  };

  handleFilterSelection = (e, data) => {
    this.setState(
      () => {
        return { [data.type]: data.value };
      },
      () => {
        this.props.filterEventChron(this.state, this.props.events);
      }
    );
  };

  handleSelectEvent = (event) => {
    browserHistory.push(
      `/events/${event.id}${
        event.aXSEvent ? '/portal/' + event.aXSEvent.eventId : ''
      }`
    );
    this.props.resetEventListing();
  };

  handleCMSEventFetch = () => {
    if (this.props.eventsType === 'cmsOnly') {
      this.props.loadEvents(false);
      browserHistory.push(`/events`);
    } else {
      this.props.loadEvents(true);
      browserHistory.push(`/events/cms`);
    }
  };

  render() {
    return (
      <div id="test-events-container">
        <NewButton
          newButtonClick={() => browserHistory.push('/event/0')}
          text="CREATE EVENT"
        />
        <div id="test-events-header" className={styles['create-event-header']}>
          <PageTitle>Events</PageTitle>
        </div>
        <div>
          {!this.props.isLoading && (
            <EventsFilterMenu
              filterSelections={this.state}
              handleFilterSelection={this.handleFilterSelection}
              times={this.props.times}
              venues={this.props.venues}
              handleCMSEventFetch={this.handleCMSEventFetch}
            />
          )}
          <EventChron
            handlePageChange={this.handlePageChange}
            handleSelectEvent={this.handleSelectEvent}
            {...this.props}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contextId: state.app.contextId,
  currentPage: state.event_chron.currentPage,
  entriesPerPage: state.event_chron.entriesPerPage,
  events: state.event_chron.events,
  eventsLoading: state.event_chron.isLoading,
  filteredEvents: state.event_chron.filteredEvents,
  isLoading: state.event_chron.isLoading,
  lastFetched: state.event_chron.lastFetched,
  sortByColumn: state.event_chron.sortByColumn,
  sortDir: state.event_chron.sortDir,
  timeFilter: state.event_chron.timeFilter,
  times: state.event_chron.times,
  venueFilter: state.event_chron.venueFilter,
  venues: state.event_chron.venues,
  eventsType: state.event_chron.eventsType,
  location: state.location,
});

const mapDispatchToProps = (dispatch) => ({
  loadEvents: (withCms) => dispatch(loadEvents(withCms)),
  loadPage: (page) => dispatch(loadEventChronPage(page)),
  sort: (column) => dispatch(sortEventChron(column)),
  filterEventChron: (data, events) => dispatch(filterEventChron(data, events)),
  resetEventListing: () => dispatch(resetEventListing()),
});

EventsContainer.propTypes = {
  contextId: PropTypes.string,
  currentPage: PropTypes.number,
  entriesPerPage: PropTypes.number,
  events: PropTypes.array,
  eventsLoading: PropTypes.bool,
  eventsType: PropTypes.string,
  filteredEvents: PropTypes.array,
  filterEventChron: PropTypes.func,
  isLoading: PropTypes.bool,
  keywordFilter: PropTypes.number,
  lastFetched: PropTypes.instanceOf(Date),
  loadEvents: PropTypes.func,
  loadPage: PropTypes.func,
  resetEventListing: PropTypes.func,
  sortByColumn: PropTypes.string,
  sortDir: PropTypes.string,
  timeFilter: PropTypes.string,
  times: PropTypes.array,
  venueFilter: PropTypes.number,
  venues: PropTypes.array,
  location: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventsContainer);



// WEBPACK FOOTER //
// ./src/routes/Events/containers/EventsContainer.js